<template>
  <div class="main-content fasilitas karir">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Info Karir</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="fasilitas-containter">
      <div class="container">
        <div class="section-title text-center">
          <div class="row">
            <div class="col-md-12">
              <h2 class="text-uppercase mt-0 line-height-1">
                Info Lowongan Pekerjaan di
                <span class="text-theme-colored">Rumah Sakit UII</span>
              </h2>
            </div>
          </div>
        </div>
        <div class="section-content mt-30">
          <div class="row">
            <i v-if="show_loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            <div v-if="!show_loading" role="tablist" class="accordion-carrier">
              <b-card v-for="item in careers" v-bind:key="item.id" no-body class="mb-1">
                <b-card-header header-tag="header" :class="'p-'+item.id" role="tab">
                  <b-button block v-b-toggle="'accordion-' + item.id">{{ item.title }}</b-button>
                </b-card-header>
                <b-collapse
                  :id="'accordion-'+item.id"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <img v-bind:src="item.picture" alt class="img-responsive" />
                    <b-card-text v-html="item.content"></b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import api from "../services/api";

export default {
  data() {
    return {
      show_loading: true,
      careers: [],
    };
  },
  mounted() {
    this.getCareers();
  },
  methods: {
    getCareers() {
      api
        .post(api.route.get.careers)
        .then((res) => {
          let status = res.status;
          if (status) this.careers = res.data;
          this.show_loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.show_loading = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Karir.vue